import React from "react";
import PracticeAreaLayout from "../components/PracticeAreaLayout";
import SeoMetaTags from "../components/SeoMetaTags";

/**
 * PersonalInjury Component
 *
 * Page component for the Personal Injury practice area
 */
function PersonalInjury() {
  return (
    <>
      <SeoMetaTags 
        slug="personal-injury"
        defaultTitle="Personal Injury Law - Sentry Law | Calgary Injury Lawyers"
        defaultDescription="Experienced personal injury lawyers in Calgary. We fight for fair compensation for motor vehicle accidents, slip and falls, and other injuries. Free consultation available."
      />
      
      <PracticeAreaLayout
        title="PERSONAL INJURY"
        content="As much as we wish it could be, being injured in a motor vehicle accident isn't an open and shut case. There are many issues that commonly arise, and everyone involved is usually looking out for their best interests. At LawyerG we look out for you. We want to see you get the best medical care to be able to return to your pre-accident health quickly so that you can return to your everyday life."
        image="/images/personal-injury.jpg" // Replace with appropriate legal image
        imageAlt="Personal Injury Law Services"
        buttonText="PERSONAL INJURY"
        buttonLink="/corporate-and-commercial"
        breadcrumbLabel="Personal Injury"
        section="areas"
      />
    </>
  );
}

export default PersonalInjury;
